import React from "react";
import style from './Pages.module.css'
import Footer from "../components/layouts/footer/Footer";
import Announcement from "../components/layouts/announcement/AnnouncementBar";
import Header from "../components/layouts/header/Header";
import Checkout from "../components/payment/checkout/Checkout";

const CheckoutPage = (props) => {
    // console.log("CheckoutPage props", props);
    return (<div className={style['container']}>
        <Announcement />
        <Header />
        <Checkout/>
        <Footer />
    </div>)
}
export default connect(CheckoutPage);